<script>
import AboutMe from "@/components/about/AboutMe";
import EducationBackground from "@/components/about/EducationBackground.vue";
import TechnicalSkills from "@/components/about/TechnicalSkills.vue";
import Testimonial from "@/components/about/Testimonial.vue";
import WorkExperiances from "@/components/about/WorkExperiances.vue";
import HomeContactForm from "@/components/home/HomeContactForm.vue";
import AppBanner from "@/components/shared/AppBanner";
import HomeRecentProjects from "../components/home/HomeRecentProjects.vue";
import PageTitle from "../components/reusable/PageTitle.vue";
import AppFooter from "../components/shared/AppFooter.vue";

export default {
  name: "Home",
  components: {
    AppBanner,
    AboutMe,
    EducationBackground,
    TechnicalSkills,
    WorkExperiances,
    Testimonial,
    HomeContactForm,
    PageTitle,
    HomeRecentProjects,
    AppFooter,
  },
};
</script>

<template>
  <div class="w-full px-4 sm:px-6 lg:px-8 xl:max-w-[1400px] xl:mx-auto">
    <AppBanner class="mb-0 md:mb-5" />

    <section id="about" class="scroll-mt-28 pt-12 md:pt-16">
      <PageTitle
        title="About"
        desc="Things about me which you may find interesting!" />
      <div class="my-14 md:my-16">
        <AboutMe />
      </div>
      <TechnicalSkills />
      <WorkExperiances />
      <EducationBackground />
      <Testimonial />
    </section>

    <HomeRecentProjects />
    <HomeContactForm />
    <AppFooter />
  </div>
</template>

<style scoped></style>
